export enum SectionId {
  Brief = 'brief',
  Protection = 'protection',
  Fastening = 'fastening',
  Efficiency = 'efficiency',
  Montage = 'montage',
  Calculator = 'calculator',
}
